import { css } from '@emotion/react';

const carouselStyles = css`
    .slider {
        height: auto;
    }
`;

export const themeCarouselStyles = css`
    background-color: var(--color-green);
    color: var(--color-white);
    font-family: 'OpenSans-Regular';
    font-weight: bold;
    font-size: var(--font-size-regular);
    height: max-content;
    width: 99%;
    padding: 20px 0;

    .slider-wrapper {
        width: 90%;
    }

    .slider {
        height: auto;
    }

    li > div {
        padding: 0 20px;
    }

    .control-dots {
        display: none;
    }
`;

export default carouselStyles;
